// extracted by mini-css-extract-plugin
module.exports = {"textValues":"textValues--2Ci2r"};